var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 3.66797C9.18784 3.66797 3.66602 9.18979 3.66602 16.0013C3.66602 22.8128 9.18784 28.3346 15.9993 28.3346C22.8108 28.3346 28.3327 22.8128 28.3327 16.0013C28.3327 9.18979 22.8108 3.66797 15.9993 3.66797ZM1.66602 16.0013C1.66602 8.08522 8.08327 1.66797 15.9993 1.66797C23.9155 1.66797 30.3327 8.08522 30.3327 16.0013C30.3327 23.9174 23.9155 30.3346 15.9993 30.3346C8.08327 30.3346 1.66602 23.9174 1.66602 16.0013Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3421 7.234C15.0855 5.94284 16.9137 5.94284 17.6572 7.234L19.6904 10.7655L23.5195 11.6925C24.9619 12.0417 25.4407 13.7939 24.5423 14.8758L21.9461 18.0018L22.2892 22.1334C22.4053 23.5327 21.0165 24.726 19.608 24.1023L15.9996 22.5043L12.3913 24.1023C10.9828 24.726 9.59395 23.5327 9.71014 22.1334L10.0532 18.0018L7.45706 14.8758C6.55863 13.7939 7.03736 12.0417 8.47986 11.6925L12.3089 10.7655L14.3421 7.234ZM16.0445 22.4846C16.0447 22.4846 16.0444 22.4846 16.0445 22.4846ZM15.9996 8.36347L14.0296 11.7852C13.7688 12.2382 13.3347 12.575 12.8157 12.7006L9.01463 13.6208L11.5965 16.7298C11.9311 17.1326 12.0891 17.6512 12.0463 18.1672L11.7101 22.2166L15.2347 20.6558C15.7227 20.4396 16.2767 20.4396 16.7647 20.6558L20.2892 22.2166L19.9529 18.1672C19.9101 17.6512 20.0681 17.1326 20.4028 16.7298L22.9847 13.6208L19.1836 12.7006C18.6647 12.575 18.2305 12.2382 17.9697 11.7852L15.9996 8.36347ZM11.5815 22.2735C11.5814 22.2735 11.5815 22.2735 11.5815 22.2735Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.1ded273d99496f3be7f84c04b22641d7.svg";
export { ForwardRef as ReactComponent };